import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import { GreyOutlinedButton } from "../Button/CustomButton";
import { colors } from "../../Styles/GlobalStyles/Variables";
import TextField from "@mui/material/TextField";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import { Box, Divider, FormHelperText, IconButton, Paper, Skeleton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  emptySkillSet,
  emptySkillSetById,
  emptySubSkillBySkillId,
  fetchSkillSet,
  restoreSkillSetInitial,
  updateMultipleSubSkill,
  updateSkillSet,
  updateSubSkill,
} from "../../Actions";
import { useSelector, useDispatch } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
import { Typography } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import StatusGenerator from "../StatusGenerator/StatusGenerator";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#e0e0e059",
  border: `1px solid ${alpha(theme.palette.common.black, 0.15)}`,
  "&:hover": {
    backgroundColor: theme.palette.common.white,
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "40ch",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(0.6, 1, 0.6, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "25ch",
      "&:focus": {
        width: "27ch",
      },
    },
  },
}));

const getSkillState = (state) => state.skillsReducer;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ViewSkillDialog(props) {
  const ToastStyle = {
    backgroundColor: "#d56b66",
    color: colors.white,
  };

  const {
    openViewSkillDialog,
    handleCloseViewSkillDialog,
    skillSet,
    updateLoadingState,
    formType,
    theParams,
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();

  const { subSkillsBySkillId, skillSetUpdated, subSkillUpdated, multipleSubSkillUpdated } =
    useSelector(getSkillState);
  const [disable, setDisable] = useState(colors.primaryGreen);
  const [skillName, setSkillName] = useState("");
  const [skillId, setSkillId] = useState(0);
  const [subSkillName, setSubSkillName] = useState(subSkillsBySkillId);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableData, setTableData] = useState(subSkillsBySkillId);
  const [subSkillUpdatedData, setSubSkillUpdatedData] = useState([])
  const [loadingButton, setLoadingButton] = useState(false);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [subSkillError, setSubSkillError] = useState(false);
  const [subSkillHelperText, setSubSkillHelperText] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [submittedArray, setSubmittedArray] = useState([]);
  const initialFormValues = {
    name: "",
    skillid: skillId,
    // subSkill: "",
  };
  const initialSubFormValues = {
    name: "",
    subSkillid: 0,
    // subSkill: "",
  };
  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [subFormValues, setSubFormValues] = useState({
    ...initialSubFormValues,
  });

  //   const itemsEls = useRef(new Array())

  useEffect(() => {
    if (Object.keys(skillSet)?.length > 0) {
      setSkillName(skillSet.name);
      setSkillId(skillSet.id);
    }
  }, [skillSet]);

  useEffect(() => {
    if (subSkillsBySkillId?.length > 0) {
      setTableData(subSkillsBySkillId);
    }
  }, [subSkillsBySkillId]);

  const handleSearchInputChange = (event) => {
    const searchQuery = event.target.value.toLowerCase();
    setSearchQuery(searchQuery);

    if (searchQuery.trim() === "") {
      // Set the table data to the initial array
      setTableData(subSkillsBySkillId);
    } else {
      // Filter the table data based on the search query
      const filteredData = subSkillsBySkillId.filter((data) =>
        data.name.toLowerCase().includes(searchQuery)
      );
      // Check if the filtered data array is empty
      if (filteredData.length === 0) {
      } else {
        // Set the table data to the filtered array
        setTableData(filteredData);
      }
    }
  };
  // const handleChange = (e, index) => {
  //   const newData = [...tableData];
  //   if(e){
  //   newData[index].name = e.target.value;
  //   setSubSkillName(newData);
  //   setIsUpdated(true)
  //   }
  //   setSubFormValues({
  //     ...subFormValues,
  //     name: newData[index].name,
  //     subSkillid: newData[index].id,
  //   })
  // };

  // const handleBlur = async(e, index) =>{
  //   if(subSkillName?.length !==0 && isUpdated === true ){
  //     if(subFormValues?.name !=="" && subFormValues?.subSkillid !==0 && subFormValues?.name?.trim()){
  //       dispatch(updateSubSkill(subFormValues))
  //     }
  //   }
  // }

  const editSkillSetHandler = (e) => {
    let newValue = e.target.value
    if (e) {
      if(newValue=== ""){
        setError(true);
        setHelperText("*Skill name is required");
      }
      setError(false);
      setHelperText("");
      let newSkillSetValue = e.target.value;
      setSkillName(newSkillSetValue);
      setFormValues({
        ...formValues,
        name: newSkillSetValue,
        skillid: skillId,
      });
    }
  };

  // const editSubSkillHandler = (e) => {
  //   setSubSkillName(e.target.value);
  //   /*  let newSubSkillValue = e.target.value; */
  //   setFormValues({
  //     ...formValues,
  //     subSkill: setSubSkillName,
  //   });
  // };

  const [updatedIds, setUpdatedIds] = useState({});


  
  const handleChange = (e, index) => {
    const newData = [...tableData];
    newData[index].name = e.target?.value;
    setSubSkillError(false);
    setSubSkillHelperText("");
    setIsUpdated(true);
    setSubSkillName((prevData) =>
      prevData?.map((item, i) =>
        i === index ? { ...item, name: newData[index]?.name } : item
      )
    );
    setSubFormValues({
      ...subFormValues,
      name: newData[index].name,
      subSkillid: newData[index].id,
    });
    setTableData((prevTableData) =>
      prevTableData.map((data) => {
        if (data.id === newData[index].id) {
          setUpdatedIds((prevIds) => [...Array.from(prevIds), data.id]); // Create new array from prevIds and add new ID
          return { ...data, name: e.target?.value };
        }
        return data;
      })
    );
    setTableData(newData);

   setSubSkillUpdatedData(tableData.map(({ name, id }) => ({ name, subSkillid: id })));
  };
  


  const handleSubmit = (e) => {
    debugger
    e.preventDefault();
    const newData = [...tableData];
    let hasError = false;
    
    newData.forEach((item) => {
      if (item?.name?.trim() === "" || item?.skillid === 0) {
        setSubSkillError(true);
        setSubSkillHelperText("*Please fill the sub skill field below");
        hasError = true;
      }
    });
    if (skillName === "") {
      setError(true);
      setHelperText("*Skill name is required");
    }
    
    if (!hasError) {
      if (
        formValues?.name !== "" &&
        formValues?.skillid !== 0 &&
        skillName !== "" &&
        skillName.trim()
      ) { 
        setLoadingButton(true);
        dispatch(updateSkillSet(formValues));
        setIsSubmitted(true);
      }
  
      if (skillName === "") {
        setError(true);
        setHelperText("*Skill name is required");
      }
  
      if (subFormValues?.name !== "" && subFormValues?.subSkillid !== 0 && skillName!=="") {
        setLoadingButton(true);
        setIsSubmitted(true);
        

        const updatedSubSkills = subSkillUpdatedData.filter((data) =>
        updatedIds.includes(data.subSkillid)

    );
        dispatch(updateMultipleSubSkill(updatedSubSkills));
      }

      setTimeout(() => {
        if (dispatch) {
          setLoadingButton(false);
        }
      }, 2000);
    }
  };
  

  useEffect(() => {
    if (isSubmitted === true) {
      if (skillSetUpdated === true || subSkillUpdated === true || multipleSubSkillUpdated === true) {
        setIsUpdated(false);
        handleClose();
        setLoadingButton(true);
        updateLoadingState();
        dispatch(fetchSkillSet(theParams));
        // resetForm();
        // setError(false)
        // setHelperText("")
      }
      return () => {
        dispatch(emptySkillSet());
        dispatch(restoreSkillSetInitial());
        setLoadingButton(false);
        setSubFormValues({ ...initialSubFormValues });
        setFormValues({ ...initialFormValues });
      };
    }
  }, [skillSetUpdated, subSkillUpdated, multipleSubSkillUpdated, isSubmitted, dispatch]);

  const handleClose = () => {
    handleCloseViewSkillDialog();
    setSkillName("");
    setSkillId("");
    setHelperText("");
    setSubSkillError(false);
    setSubSkillHelperText("");
    setError(false);
    setIsSubmitted(false);
    setIsUpdated(false);
    dispatch(emptySkillSetById());
    dispatch(emptySubSkillBySkillId());
  };
  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Dialog
        fullWidth={true}
        fullScreen={fullScreen}
        open={openViewSkillDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          style: { borderRadius: 20, padding: 10 },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          id="responsive-dialog-title"
        >
          {formType === "view" ? "View" : "Edit"} Skill
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent
          sx={{
            padding: "0px 10px",
            textTransform: "capitalize",
            "&::-webkit-scrollbar": {
              width: 5,
              height: 5,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#fff",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#DCDCDC",
              borderRadius: 2,
            },
          }}
        >
          <Box>
            {formType === "edit" ? (
              Object.keys(skillSet)?.length > 0 ? (
                <div style={{ marginTop: "20px" }}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={1}
                    mb={1}
                  >
                    <Typography
                      sx={{ color: colors.primaryGrey, fontSize: "12px" }}
                    >
                      Name of Skill
                    </Typography>
                    {Object.keys(skillSet)?.length > 0 ? (
                      skillSet?.isActive === true ? (
                        <StatusGenerator
                          statusText="Active"
                          variant="greenFilled"
                        />
                      ) : (
                        <StatusGenerator
                          statusText="Inactive"
                          variant="redFilled"
                        />
                      )
                    ) : (
                      <Skeleton variant="rounded" width={50} height={30} />
                    )}
                  </Box>

                  <TextField
                    onChange={(e) => {
                      editSkillSetHandler(e);
                    }}
                    inputProps={{ style: { padding: "10px" } }}
                    size="small"
                    fullWidth
                    value={skillName}
                    variant="outlined"
                    error={error}
                    helperText={helperText}
                  />
                </div>
              ) : (
                <Skeleton variant="rounded" height={50} />
              )
            ) : (
              <Paper
                elevation={0}
                variant="outlined"
                sx={{
                  pl: 2,
                  pr: 2,
                  pt: 1,
                  pb: 1,
                  mt: 3,
                  ml: 2,
                  mr: 2,
                  background: "#ecf8f240",
                }}
              >
                <Box
                  justifyContent="space-between"
                  alignItems="center"
                  display="flex"
                  textTransform="initial"
                >
                  <div>
                    <Typography
                      sx={{ color: colors.primaryGrey, fontSize: "12px" }}
                    >
                      Name of Skill
                    </Typography>
                    <Typography
                      sx={{ fontWeight: 700, mb: 0.5 }}
                      variant="subtitle1"
                    >
                      {Object.keys(skillSet)?.length > 0 ? (
                        skillSet.name
                      ) : (
                        <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                      )}
                    </Typography>
                  </div>
                  <div>
                    {Object.keys(skillSet)?.length > 0 ? (
                      skillSet?.isActive === true ? (
                        <StatusGenerator
                          statusText="Active"
                          variant="greenFilled"
                        />
                      ) : (
                        <StatusGenerator
                          statusText="Inactive"
                          variant="redFilled"
                        />
                      )
                    ) : (
                      <Skeleton variant="rounded" width={50} height={30} />
                    )}
                  </div>
                </Box>
                <Divider />
                <Box
                  justifyContent="space-between"
                  alignItems="center"
                  display="flex"
                  mt="10px"
                  textTransform="initial"
                >
                  <div>
                    <Typography
                      sx={{ color: colors.primaryGrey, fontSize: "12px" }}
                    >
                      No of Sub Skill(s)
                    </Typography>
                    <Typography
                      sx={{ fontWeight: 700, mb: 0.5 }}
                      variant="subtitle1"
                    >
                      {Object.keys(skillSet)?.length > 0 ? (
                        subSkillsBySkillId?.length
                      ) : (
                        <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                      )}
                    </Typography>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <Typography
                      sx={{ color: colors.primaryGrey, fontSize: "12px" }}
                    >
                      Date Activated
                    </Typography>
                    <Typography
                      sx={{ fontWeight: 700, mb: 0.5 }}
                      variant="subtitle1"
                    >
                      {Object.keys(skillSet)?.length > 0 ? (
                        moment(skillSet?.dateModified).format("DD/MM/YYYY")
                      ) : (
                        <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                      )}
                    </Typography>
                  </div>
                </Box>
              </Paper>
            )}

            {Object.keys(skillSet)?.length > 0 && subSkillsBySkillId?.length ? (
              <Box sx={{ flexGrow: 1 }}>
                {subSkillsBySkillId?.length > 3 ? (
                  <Paper elevation={0} sx={{ mt: 3, ml: 2, mr: 2 }}>
                    <Search>
                      <SearchIconWrapper>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search for subskills..."
                        inputProps={{
                          "aria-label": "search",
                          fontSize: "10px",
                        }}
                        onChange={(e) => handleSearchInputChange(e)}
                        sx={{
                          "& input::placeholder": {
                            fontSize: "12px",
                          },
                        }}
                      />
                    </Search>
                  </Paper>
                ) : (
                  ""
                )}
                <Paper elevation={0} sx={{ mt: 3, ml: 2, mr: 2 }}>
                  <Box sx={{ mb: 1 }}>
                    <Typography sx={{ fontWeight: 700 }} variant="subtitle2">
                      SUB SKILLS  {subSkillError? <FormHelperText>
                                        <span style={{color:'red'}}>{subSkillHelperText}</span>
                                        </FormHelperText>:""}
                    </Typography>
                  </Box>
                  <Box>
                    <TableContainer component={Paper} elevation={0}>
                      {/* MuiTableCell-root */}
                      <Table aria-label="simple table" size="small">
                        {tableData?.length > 0 ? (
                          <TableBody>
                            {tableData?.map((item, index) => {
                              return (
                                <TableRow
                                  key={index}
                                  sx={{ border: "0px !important" }}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ padding: "8px 0px" }}
                                  >
                                    <div style={{ display: "flex", gap: 10 }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {index + 1}.
                                      </div>
                                      <div>
                                        <InputBase
                                          size="small"
                                          value={item.name}
                                          readOnly={
                                            true ? formType === "view" : false
                                          }
                                          onChange={(e) =>
                                            handleChange(e, index)
                                          }
                                         
                                          inputProps={{
                                            style:
                                              formType === "edit"
                                                ? {
                                                    border: `1px solid ${colors.primaryGrey}`,
                                                    padding: "5px 10px",
                                                    borderRadius: "5px",
                                                    width: "450px",
                                                  }
                                                : formType === "view"
                                                ? {
                                                    border: "0px",
                                                    width: "450px",
                                                  }
                                                : {},
                                          }}
                                        />
                                       {/*  {subSkillError? <FormHelperText>
                                        <p style={{color:'red'}}>{subSkillHelperText}</p>
                                        </FormHelperText>:""} */}
                                      </div>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        ) : (
                          <Skeleton variant="rounded" height={100} />
                        )}
                      </Table>
                    </TableContainer>
                  </Box>
                </Paper>
              </Box>
            ) : (
              ""
            )}
          </Box>
        </DialogContent>
        {/* <Divider/> */}
        <DialogActions sx={{ textTransform: "capitalize", p: 3 }}>
          <GreyOutlinedButton
            sx={{ padding: "5px 15px" }}
            autoFocus
            onClick={handleClose}
          >
            <Typography>Close</Typography>
          </GreyOutlinedButton>
          {formType === "edit" ? (
            <LoadingButton
              color="primary"
              sx={{
                padding: "5px 15px",
                fontFamily: Typography.secondaryFont,
                color: colors.white,
                backgroundColor: disable,
                textTransform: "inherit",
                // padding: theme.spacing(2),
                "&:hover": {
                  backgroundColor: colors.darkGreen,
                },
              }}
              onClick={handleSubmit}
              autoFocus
              loading={loadingButton}
              endIcon={<SaveAsIcon />}
              // loadingIndicator="Adding..."
            >
              Save
            </LoadingButton>
          ) : (
            ""
          )}
        </DialogActions>
        <ToastContainer toastStyle={ToastStyle} />
      </Dialog>
    </ThemeProvider>
  );
}

// resetForm();
// return () => {
//   dispatch(restoreRoleInitial());
// };
